import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'html-react-parser';
import isObject from 'lodash/isObject';

import styles from './Body.scss';

export const Body = props => {
  const { children, formattedText } = props;

  const text =
    isObject(children) && Reflect.has(children, 'processed')
      ? children.processed
      : children;

  if (formattedText) {
    return <div className="formattedText">{ReactHtmlParser(text)}</div>;
  }

  return ReactHtmlParser(text);
};

Body.propTypes = {
  children: PropTypes.any,
  formattedText: PropTypes.bool,
};
